export const FIND_FILTER_LIST_KEYS = [
  'sites',
  'eras',
  'findTypes',
  'materials',
  'groups',
  'tags',
] as const;

export type FindFilterListKey = typeof FIND_FILTER_LIST_KEYS[number];
export const EMPTY_FIND_FILTER_LIST_KEYS: readonly FindFilterListKey[] = [];

export interface FindFilterValue {
  id?: string;
  stored?: boolean;
  sites?: string[];
  eras?: string[];
  findTypes?: string[];
  materials?: string[];
  groups?: string[];
  tags?: string[];
  hasImages?: boolean;
  hasAmcrId?: boolean;
}

export type StoredFindFilter = Omit<FindFilterValue, 'id' | 'stored'>;

export function cleanFindFilter(
  filter: FindFilterValue | null | undefined,
  omittedKeys: readonly FindFilterListKey[] = []
): StoredFindFilter | null {
  if (!filter) {
    return null;
  }

  const omitted = new Set<FindFilterListKey>(omittedKeys);
  const cleaned: StoredFindFilter = {};

  FIND_FILTER_LIST_KEYS.forEach((key) => {
    const values = filter[key];
    if (!omitted.has(key) && values?.length) {
      cleaned[key] = [...values];
    }
  });

  if (filter.hasImages != null) {
    cleaned.hasImages = filter.hasImages;
  }

  if (filter.hasAmcrId != null) {
    cleaned.hasAmcrId = filter.hasAmcrId;
  }

  return Object.keys(cleaned).length ? cleaned : null;
}

export function countFindFilterDimensions(
  filter: FindFilterValue | null | undefined
): number {
  if (!filter) {
    return 0;
  }

  const listCount = FIND_FILTER_LIST_KEYS.filter(
    (key) => !!filter[key]?.length
  ).length;

  return (
    listCount +
    (filter.hasImages == null ? 0 : 1) +
    (filter.hasAmcrId == null ? 0 : 1)
  );
}
